import Vue from 'vue'
import Router from 'vue-router'
import Frame from '../components/layout.vue'
import Login from '../pages/login'//登录
import Error401 from '../components/401'
import Error404 from '../components/404'

import adPage from '../pages/adPut/start_page';
//基础信息组件
const Custom = () => import('@/pages/baseInfo/customerList')
const Adver = () =>  import('@/pages/baseInfo/adverList')
//广告投放组件
const HomePage = () => import('@/pages/adPut/homePage')
const Instant = () => import('@/pages/adPut/instant')
const Plaque = () => import('@/pages/adPut/plaque')
const SoftWen = () => import('@/pages/adPut/softWen')
const TailAd = () => import('@/pages/adPut/tailAd')
const PagingAd = () => import('@/pages/adPut/pagingAd')
//系统设置组件
const Account = () => import('@/pages/systemSet/account')
const Role = () => import('@/pages/systemSet/role')
const Permiss = () => import('@/pages/systemSet/permiss')
const Dics = () => import('@/pages/systemSet/dictionary')
//广告审核组件
const Ebus =() => import('@/pages/adcheck/ebus')
const Operator =() => import('@/pages/adcheck/operator')


Vue.use(Router)
const routes=[
  {path: '/login', component: Login},
  {path:'/401',component: Error401},
  {path:'/404',component: Error404},
  {
    path:'/',
    component:Frame,
    name:'基本信息',
    children:[
      {path:'/customerList',component:Custom,name:'客户信息维护'},
      {path:'/adverList',component:Adver,name:'广告位维护'}
    ]
  }, {
    path:'/',
    component:Frame,
    name:'系统设置',
    children:[
      {path:'/account',component:Account,name:'账号管理'},
      {path:'/role',component:Role,name:'角色管理'},
      {path:'/permiss',component:Permiss,name:'菜单设置'},
      {path:'/dics',component:Dics,name:'字典管理'}
    ]
  },{
    path:'/',
    component:Frame,
    name:'广告审核',
    children:[
      {path:'/ebus',component:Ebus,name:'东部公交'},
      {path:'/operator',component:Operator,name:'运营商'},
    ]
  },{
    path:'/',
    component:Frame,
    name:'广告投放',
    children:[
      {path:'/softWen',component:SoftWen,name:'软文广告'},
      {path:'/homePage',component:HomePage,name:'首页轮播'},
      {path:'/instant',component:Instant,name:'即时消息'},
      {path:'/plaque',component:Plaque,name:'插屏广告'},
      {path:'/openScreenAdvertise',component:TailAd,name:'开屏广告'},
      {path:'/pageShuff',component:PagingAd,name:'分页广告'}
    ]
  }
];
const router=new Router({routes});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js


// WEBPACK FOOTER //
// ./src/router/index.js